module.exports = __webpack_public_path__ + "img/IMG_2248_L_BlackMatted.8602674d.jpg";